import { PlatformSDKShape } from '../PlatformSDKShape';
import { BaseSDKShape } from '../BaseSDKShape';

export class PanelsSDKShape extends BaseSDKShape {
  async openLanguageSupportPanel() {
    const privateAPI = await this.getPlatformPrivateAPI();
    return privateAPI.panels.openLanguageSupportPanel();
  }

  async openFontsUploadPanel() {
    const privateAPI = await this.getPlatformPrivateAPI();
    return privateAPI.panels.openFontsUploadPanel();
  }
}

export default new PlatformSDKShape(PanelsSDKShape)
  .withPublicMethod('openLanguageSupportPanel')
  .withPublicMethod('openFontsUploadPanel')
  .build();
